import { debounce } from './helpers';

((Drupal, once, $) => {
  Drupal.behaviors.ukhcChapterCarousel = {
    attach(context) {
      once('ukhc-chapter-carousel', '.chapter-carousel', context).forEach((wrapper) => {
        const feed = wrapper.querySelector('.chapter-carousel__feed');

        if (!feed) {
          return;
        }

        const $wrapper = $(wrapper);
        const $feed = $(feed);
        const $controls = $wrapper.find('.chapter-carousel__controls');
        const $prev = $wrapper.find('.chapter-carousel__arrow--prev');
        const $next = $wrapper.find('.chapter-carousel__arrow--next');

        const maxScroll = () => feed.scrollWidth - feed.clientWidth;

        /**
         * scrollLeft values that bring each card to the resting position of the
         * first one, measured from the live layout so uneven card margins can't
         * put the step out of sync with the cards.
         */
        const stops = () => {
          const feedLeft = feed.getBoundingClientRect().left;
          const offsets = $feed
            .find('.chapter-carousel__row')
            .toArray()
            .map((card) => card.getBoundingClientRect().left - feedLeft + feed.scrollLeft);

          if (!offsets.length) {
            return [];
          }

          const limit = maxScroll();

          return offsets.map((offset) => Math.min(Math.max(offset - offsets[0], 0), limit));
        };

        const step = (direction) => {
          const positions = stops();
          const target =
            direction > 0
              ? positions.find((position) => position > feed.scrollLeft + 1)
              : positions.reverse().find((position) => position < feed.scrollLeft - 1);

          if (target !== undefined) {
            // No behavior: defers to scroll-behavior, which honours reduced motion.
            feed.scrollTo({ left: target });
          }
        };

        const updateControls = () => {
          const limit = maxScroll();

          $controls.toggleClass('chapter-carousel__controls--inert', limit < 1);
          $prev.attr('aria-disabled', feed.scrollLeft < 1);
          $next.attr('aria-disabled', feed.scrollLeft >= limit - 1);
        };

        const onArrow = (direction) => (event) => {
          if (event.currentTarget.getAttribute('aria-disabled') === 'true') {
            return;
          }

          step(direction);
        };

        $prev.on('click', onArrow(-1));
        $next.on('click', onArrow(1));

        $feed.on('scroll', updateControls);
        $(window).on('resize', debounce(updateControls, 100));
        updateControls();
      });
    },
  };
})(Drupal, once, jQuery);
